import { znithMark } from "@/lib/images";
import { Picture } from "./Picture";

export function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-border/60 bg-midnight py-12">
      <div className="absolute inset-x-0 top-0 gold-divider" />

      <div className="container-narrow flex flex-col items-center gap-6 text-center">
        {/* Logo + wordmark */}
        <div className="flex flex-col items-center gap-3">
          <Picture
            pic={znithMark}
            alt="ZNITH AI logo"
            sizes="52px"
            width={56}
            height={44}
            className="h-10 w-auto"
          />
          <p className="text-2xl font-extrabold tracking-[0.22em] text-ivory">
            ZNITH
          </p>
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold">
            SPRINT CODE · Inteligência aplicada
          </p>
        </div>

        {/* Versículo Josué 1:9 */}
        <div className="flex w-full max-w-xl flex-col items-center gap-4">
          <div className="flex w-full items-center gap-4">
            <span className="h-px flex-1 bg-gold/30" />
            <span className="text-gold/70">✦</span>
            <span className="h-px flex-1 bg-gold/30" />
          </div>
          <blockquote
            className="text-pretty text-lg italic leading-relaxed text-ivory/85 md:text-xl"
            style={{ fontFamily: "var(--font-display)" }}
          >
            “Sê forte e corajoso. Não temas, nem te apavores.”
          </blockquote>
          <cite className="text-xs uppercase not-italic tracking-[0.3em] text-gold-soft">
            — Josué 1:9
          </cite>
        </div>

        {/* Atribuição */}
        <div className="flex flex-col items-center gap-2 border-t border-border/40 pt-6 text-xs text-slate-muted">
          <a
            href="https://znithai.com.br"
            className="tracking-[0.2em] text-ivory/70 transition-colors hover:text-gold"
            target="_blank"
            rel="noreferrer"
          >
            znithai.com.br
          </a>
          <p>© {new Date().getFullYear()} ZNITH.AI · Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
